// VERA-304 (Slice 3a) — evidence level a transfer completed with.
//   Transferred: ledger moved with no recipient action (admin/store push) — initiator's
//     authority only.
//   Claimed: recipient authenticated + accepted — the recipient controls the invited inbox.
//   ScanClaimed: recipient also scanned the physical NFC tag — physical possession proven.
export enum TransferCompletionMethod {
  Transferred = 'transferred',
  Claimed = 'claimed',
  ScanClaimed = 'scan_claimed',
}
